module.exports = __webpack_public_path__ + "img/M007-17_jrb-02.3cef3fc6.jpg";